import { AppState } from "store";
import { DocumentsFiltersArgs } from "./types";

export const documentsFiltersSelector = ({
  filters,
}: AppState): DocumentsFiltersArgs => {
  return filters.documents;
};
